import { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CircularProgress } from '@mui/material';
import useTitle from '../Hooks/useTitle';
import axios from 'axios';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const VerifyEmail = () => {
    useTitle('Email Verification');
    const { token } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        const verifyEmail = async () => {
            try {
                const response = await axios.post('https://api.happiclips.com/api/user/verify-email', {
                    token: token
                });
                console.log('Verification response:', response.data);
                toast.success('Email verified successfully!');
                setSuccess(true);
            } catch (err) {
                console.error('Verification error:', err);
                setError(err.response?.data?.message || 'Email verification failed');
                toast.error(err.response?.data?.message || 'Email verification failed');
            } finally {
                setLoading(false);
            }
        };

        if (token) {
            verifyEmail();
        }
    }, [token]);

    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
                <div className="bg-white p-8 rounded-lg shadow-lg text-center">
                    <CircularProgress size={60} className="mb-4" />
                    <h2 className="text-2xl font-semibold text-gray-700">Verifying your email...</h2>
                    <p className="text-gray-500 mt-2">Please wait while we verify your email address</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
                <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-md w-full mx-4">
                    <div className="flex justify-center mb-4">
                        <FaTimesCircle className="text-red-500 text-6xl" />
                    </div>
                    <h2 className="text-2xl font-bold text-red-600 mb-4">Verification Failed</h2>
                    <p className="text-gray-600 mb-6">{error}</p>
                    <Link 
                        to="/login" 
                        className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-200"
                    >
                        Return to Login
                    </Link>
                </div>
            </div>
        );
    }

    if (success) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
                <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-md w-full mx-4">
                    <div className="flex justify-center mb-4">
                        <FaCheckCircle className="text-green-500 text-6xl" />
                    </div>
                    <h2 className="text-2xl font-bold text-green-600 mb-4">Email Verified Successfully!</h2>
                    <p className="text-gray-600 mb-6">Your email has been verified. You can now proceed to login.</p>
                    <Link 
                        to="/" 
                        className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-200"
                    >
                        Proceed to Login
                    </Link>
                </div>
            </div>
        );
    }

    return null;
}

export default VerifyEmail